import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken () {
  if (process.env.NODE_ENV === 'development') {
    // return '%03%28%5C%22%05vT3%012UvS%60We%05x'
    return Cookies.get(TokenKey)
  } else {
    // return '%03%28%5D%23T%27W0UfQrUfUg%03%7E'
    return Cookies.get(TokenKey)
  }
}

export function setToken (token) {
  return Cookies.set(TokenKey, token, { expires: 30 })
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function setCookie (name, token, expires = 30) {
  return Cookies.set(name, token, { expires: expires })
}

export function getCookie (name) {
  return Cookies.get(name)
}

export function removeCookie (name) {
  return Cookies.remove(name)
}

// 生成UUID
export function getUuid (){
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var id = s.join("");
  return id;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js